<template>
  <div class="plan-benefits flex flex-wrap gap-1 justify-between text-xs md:text-sm whitespace-nowrap max-w-[410px] md:max-w-[460px] mx-auto w-full pt-7 pb-1 px-3 -mt-5 mb-1 rounded-b-md">
    <div class="flex flex-col gap-1">
      <div class="flex items-center gap-1">
        <svg-icon name="callout-check" class="w-3 h-3" :class="checkColor" />
        {{ $t('/bundler.savings_off_first_order', { firstSavings: displayFirstSavings }) }}
      </div>
      <div class="flex items-center gap-1">
        <svg-icon name="callout-check" class="w-3 h-3" :class="checkColor" />
        {{ $t('/bundler.savings_off_future_orders', { savings: pricing.savings }) }}
      </div>
    </div>
    <div class="flex flex-col gap-1">
      <div class="flex items-center gap-1">
        <svg-icon name="callout-check" class="w-3 h-3" :class="checkColor" />
        <span v-html="$t('/bundler.5_day_email_reminder_cancel_anytime')" />
      </div>
      <div class="flex items-center gap-1">
        <svg-icon name="callout-check" class="w-3 h-3" :class="checkColor" />
        {{ $t('/bundler.free_new_flavor_with_every_box') }}
      </div>
    </div>
   </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useReferralStore } from '@/stores'
import { calculateReferralSavings } from '@/utils'
import type { BundlePricing } from '@/types'

export interface Props {
  plan: string
  pricing: BundlePricing
}

const props = defineProps<Props>()
const referralStore = useReferralStore()
const { hasReferral, discountCents } = storeToRefs(referralStore)

const checkColor = computed<string>(() => props.plan === 'subscription' ? 'text-green-400' : 'text-gray-300')

const displayFirstSavings = computed(() => {
  if (!hasReferral.value || !props.pricing) return props.pricing.firstSavings
  
  const savingsAmount = calculateReferralSavings(props.pricing.onetimeCents, props.pricing.minCents, discountCents.value)
  return `$${savingsAmount}`
})
</script>
